import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VolunteerSupportService } from '@app/core/services/volunteer-support.service';
import { User } from '@app/entity';
import { AuthService } from '@app/core/services';

@Component({
  selector: 'app-personal-help-popup',
  templateUrl: './personal-help-popup.component.html',
  styleUrls: ['./personal-help-popup.component.scss']
})
export class PersonalHelpPopupComponent implements OnInit {
  @Input() isPopupOpen: boolean;
  @Output() onClose = new EventEmitter<boolean>();

  form: FormGroup;
  apiErrors = {};
  isLoading = false;
  isSentSuccessfully: boolean;

  constructor(
    private fb: FormBuilder,
    private volunteerSupportService: VolunteerSupportService,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', ],
      phone: ['', ],
      body: ['', ],
    });

    this.authService.user
      .subscribe(user => user ? this.form.patchValue({ ...user, name: user.username }) : null);
  }

  closePopup() {
    this.onClose.next();
  }

  submit() {
    if (this.isLoading) return;

    this.isLoading = true;

    this.apiErrors = {};

    this.volunteerSupportService.sendVolunteerSupportApplication(this.form.value)
      .finally(() => this.isLoading = false)
      .subscribe(response => this.isSentSuccessfully = true, error => {
        this.apiErrors = error.error;
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/personal-help-popup/personal-help-popup.component.ts